import { SxProps, Theme } from '@mui/system';
import { CSSObject, Theme as ThemeStyles, styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import { CommonColors } from '@/Themes';

const sidebarWidth = 350;

export const openedMixin = (theme: ThemeStyles): CSSObject => ({
  width: sidebarWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

export const closedMixin = (theme: ThemeStyles): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 10px)`,
  },
});

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: sidebarWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  color: CommonColors.bismark,
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  // padding: theme.spacing(0, 1),
  marginTop: '64px',
  ...theme.mixins.toolbar,
}));

export const tabContentStyles: SxProps<Theme> = {
  height: `calc(100vh - 250px)`,
  overflow: 'auto',
};
